import axios from "axios";

const STORAGE_KEY = "chacal-auth";

// Attach Authorization header to every outgoing request
axios.interceptors.request.use((config) => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) {
      const { token } = JSON.parse(raw);
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
  } catch {
    // ignore parse errors
  }
  return config;
});

// Auto-logout on 401 responses, AND dispatch a global event whenever the
// backend returns a structured error envelope (presence of `error_kind`)
// so the ErrorProvider can pop a dialog without per-component wiring.
//
// The error is still rejected as usual, so existing per-component
// try/catch flows continue to work — this is additive, not replacing.
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid — clear auth and redirect to login
      localStorage.removeItem(STORAGE_KEY);
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    } else if (error?.response?.data?.error_kind) {
      // Structured backend error → notify the global ErrorProvider.
      try {
        window.dispatchEvent(
          new CustomEvent("chacal-api-error", { detail: error }),
        );
      } catch {
        // CustomEvent may be unavailable in some test envs — ignore.
      }
    }
    return Promise.reject(error);
  },
);
